import { PaymentPlanHistoryTable } from '@/components/Payouts/PaymentPlanHistoryTable';
import { useGetOrganizationPaymentPlanHistoryQuery } from '@/services/organizations';
import { OrganizationNode } from '@/types/Organizations';
import { Box, Card } from '@palmetto/palmetto-components';

import { ProgramType } from 'types';

import PaymentCardHeader from '../components/PaymentCardHeader';

interface PaymentPlanProps {
  organization: OrganizationNode;
  programType: ProgramType;
}

export const PaymentPlanHistory = ({ organization, programType }: PaymentPlanProps) => {
  const { data: paymentPlanHistory } = useGetOrganizationPaymentPlanHistoryQuery({
    alias: organization.alias,
    programType: programType,
  });
  const renderPaymentPlan = (content: React.ReactNode) => (
    <Card>
      <PaymentCardHeader cardTitle="Payment Plan History" />
      {content}
    </Card>
  );
  if (!paymentPlanHistory) {
    return renderPaymentPlan(
      <Box alignItems="center" justifyContent="space-evenly" height="300px">
        <Box>No Payment Plan History</Box>
      </Box>,
    );
  }

  return renderPaymentPlan(<PaymentPlanHistoryTable paymentPlans={paymentPlanHistory} />);
};
